// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Qna-z","beautyGrouping":"Rna-z","beautySwatches":"Sna-z"};